import { render, staticRenderFns } from "./SelectSupplierProducts.vue?vue&type=template&id=65bd1200&scoped=true"
import script from "./SelectSupplierProducts.vue?vue&type=script&lang=js"
export * from "./SelectSupplierProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bd1200",
  null
  
)

export default component.exports